import { render, staticRenderFns } from "./StoryItem.vue?vue&type=template&id=646ebc41"
import script from "./StoryItem.vue?vue&type=script&lang=js"
export * from "./StoryItem.vue?vue&type=script&lang=js"
import style0 from "./StoryItem.vue?vue&type=style&index=0&id=646ebc41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports